<app-widget-header
  (removeWidget)="removeItem.emit($event)"
  [buttons]="widgetButtons"
  [editMode]="editMode"
  [gridsterItem]="gridsterItem"
  [hideEdit]="false"
  [widgetTitle]="name">
</app-widget-header>

<dx-tab-panel
  #tabPanelComponent
  (onItemRendered)="dispatchResizeEvent()"
  *ngIf="chartsToPlot.length > 1"
  [(selectedIndex)]="currentSelectedChartIndex"
  [animationEnabled]="true"
  [dataSource]="chartsToPlot"
  [itemTemplate]="'chart'"
  [itemTitleTemplate]="'chartTitle'"
  [repaintChangesOnly]="false"
  [scrollByContent]="true"
  [scrollingEnabled]="true"
  [showNavButtons]="true"
  [style.height]="'100%'"
  [swipeEnabled]="false">
  <div *dxTemplate="let title of 'chartTitle'; index as index" class="chartTitleWrapper">
    {{ title.name }}
    <dx-button
      (onClick)="this.openEditPopup(false, index); $event.event!.stopPropagation()"
      *ngIf="editMode"
      [height]="25"
      [style.margin-left.px]="5"
      [width]="25"
      stylingMode="text">
      <i class="vr-ic_fluent_edit_24_regular" style="font-size: 20px"></i>
    </dx-button>
    <dx-button
      (onClick)="deleteChart(title.name, index); $event.event!.stopPropagation()"
      *ngIf="editMode"
      [height]="25"
      [style.margin-left.px]="5"
      [width]="25"
      stylingMode="text">
      <i class="vr-ic_fluent_delete_24_regular" style="font-size: 20px"></i>
    </dx-button>
  </div>
  <div *dxTemplate="let chartToPlot of 'chart'" style="height: 100%;">
    <app-charts
      #chartsComponent
      [isWidget]="true"
      [style.height]="'100%'"
      [userMetricGroup]="chartToPlot">
    </app-charts>
  </div>
</dx-tab-panel>

<app-charts
  #chartsComponent
  *ngIf="chartsToPlot.length === 1"
  [isWidget]="true"
  [style.height]="'100%'"
  [userMetricGroup]="chartsToPlot[0]"
  style="position: relative">
</app-charts>

<app-widget-placeholder (configurationCallback)="this.openEditPopup(true)" *ngIf="chartsToPlot.length === 0"
                        icon="data_area"></app-widget-placeholder>

<dx-popup
  (onShowing)="initForm(isCreate)"
  [(visible)]="popupOpen"
  [dragEnabled]="false"
  [enableBodyScroll]="true"
  [fullScreen]="appService.isSmallScreen()"
  [showCloseButton]="true"
  [showTitle]="true"
  title="{{ 'WIDGETS.NAMES.MULTI_CHART' | translate}}">
  <div
    style="
    height: 100%;
    display:flex;
    flex-direction: column;
    gap: 16px;
    overflow: hidden;">
    <dx-select-box
      (onItemClick)="checkForRealReload($event)"
      [dataSource]="dashboardService.userMetricGroups"
      [disabled]="!dashboardService.userMetricGroups || dashboardService.userMetricGroups.length === 0"
      [displayExpr]="'name'"
      [dropDownOptions]="{
        wrapperAttr:{ class: 'userMetricGroupSelectionWrapper'}
      }"
      [value]="userMetricGroup"
      class="smallerInputField"
      label="{{'CHART_CREATION.USER_METRIC_GROUPS' | translate}}">
    </dx-select-box>

    <app-chart-time-selector
      (bucketIsValid)="bucketIsValid = $event"
      (dateIsValid)="dateIsValid = $event"
      [userMetricGroup]="fullUserMetricGroup"
      #chartTimeSelectorComponent>
    </app-chart-time-selector>

    <div style="
    flex: 1 1 100%;
    overflow: hidden;">
      <app-chart-metrics-table
        *ngIf="popupOpen && !!fullUserMetricGroup && fullUserMetricGroup.metrics"
        [selectedMetrics]="fullUserMetricGroup.metrics"
        style="overflow: hidden">
      </app-chart-metrics-table>
    </div>

    <div
      style="
      display: flex;
      justify-content: end;
      gap: 16px">
      <dx-button
        (onClick)="checkDateRange(); saveChart();"
        [disabled]="!fullUserMetricGroup || saveRequestSent || !dateIsValid || !bucketIsValid"
        [stylingMode]="'contained'"
        [type]="'default'"
        icon="save"
        text="{{'BUTTONS.SAVE' | translate}}"></dx-button>
    </div>
  </div>
</dx-popup>
